import './Footer.css'
import React from 'react'

export default function Footer(){
    return (
        <footer className="footer">
            <small>&copy; 2022 Theory Revolution & Katie Hom  </small>
        </footer>
    )
}